<button
  mat-raised-button
  color="primary"
  (click)="openSignature()"
  type="button"
  *ngIf="showButton$ | async"
>
  Signature
</button>
